import React, {useEffect} from "react";
import { FormattedMessage } from "react-intl";
import "./WithdrawalForm.style.scss";
import GlobalConst from "../../constants/GlobalConst";
import Currency from "../Currency/Currency";
import useDeviceType from "../../hooks/useDeviceType";

const WithdrawalForm = ({ amount, onAmountChange, onSubmit, canWithdraw }) => {
    const {isDesktop} = useDeviceType();

    useEffect(() => {
        if(isDesktop)
            document.getElementById("withdrawalAmount").focus();
    }, []);

    return (
        <div className="WithdrawalForm">
            <label className="withdrawalLabel" htmlFor="withdrawalAmount">
                <FormattedMessage id="myAccountView.withdrawFunds.enterMinAmount" values={{amount: <Currency value={GlobalConst.MIN_WITHDRAW_FUNDS} removeDecimal/> }} />
            </label>
            <input
                id="withdrawalAmount"
                type="number"
                value={amount}
                onChange={(e) => onAmountChange(Number(e.target.value))}
                className="withdrawalInput"
                min={GlobalConst.MIN_WITHDRAW_FUNDS}
            />
            <button
                className="withdrawalButton"
                onClick={onSubmit}
                // disabled={!canWithdraw}
            >
                <FormattedMessage id="myAccountView.withdrawFunds.requestWithdrawal" />
            </button>
        </div>
    );
};

export default WithdrawalForm;
